import { convertStringToHTMLFormattedString } from "../../../common-utils";
import "./homepageCompetitions.css";
import { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import { CompetitionCTAMacroParamsObject } from "../../../common";
import { getCompetitionCTAMacroParameters } from "../../../common-service";

export const HeadingAndDescription = () => {
  const [description, setDescription] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [title, setTitle] = useState<string>("Explore Our Competitions");

  useEffect(() => {
    getTextFromUmbraco();
  }, []);

  const getTextFromUmbraco = async () => {
    try {
      const response = await getCompetitionCTAMacroParameters();
      const { macroParameters } = (await response.json()) as CompetitionCTAMacroParamsObject;
      setTitle(macroParameters.title || "Explore Our Competitions");
      setDescription(macroParameters.description || "");
      setIsLoading(false);
    } catch (err) {
      console.log(`Error while fetching the Competition CTA Macro Parameters - ${JSON.stringify(err)}`);
    }
  };

  return (
    <div className={"flex items-end max-lg:pt-3 lg:pb-[22px] lg:absolute inset-x-0 w-full bottom-0"}>
      <div
        className={`w-full max-w-[1360px] mx-auto relative flex max-lg:flex-col lg:items-center lg:gap-6 ${isLoading ? "max-lg:min-h-[38px] invisible" : ""}`}>
        <div className="flex justify-center pb-2.5 lg:pb-[22px] lg:border-b lg:border-b-[#21231F] relative z-[1] descriptionContainerParent">
          <div
            className="flex gap-4 lg:gap-6 justify-center items-center descriptionContainer"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(convertStringToHTMLFormattedString(description)),
            }}
          />
        </div>
      </div>
    </div>
  );
};
